<template>
  <main>
    <!-- Hero section -->
    <div
      class="relative bg-cover bg-center"
      :style="{
        backgroundImage: `url(${require('../assets/images/contact-group.jpg')})`,
      }"
    >
      <div class="absolute inset-0 bg-black bg-opacity-50"></div>
      <div
        class="relative md:px-12 sm:px-12 px-2 max-w-screen-2xl mx-auto z-10 h-[30vh] lg:h-[60vh] flex items-center justify-start text-white"
      >
        <!-- MMC Section -->
        <h1
          class="text-4xl md:text-6xl px-4 lg:px-1 font-bold animate__animated animate__backInLeft"
        >
          Contact Us
        </h1>
      </div>

      <!-- Sleek Arch SVG Curve -->
      <svg
        class="absolute bottom-0 left-0 w-full"
        viewBox="0 0 1440 100"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill="#ffffff"
          d="M0,0 C480,100 960,100 1440,0 L1440,100 L0,100 Z"
        />
      </svg>
    </div>

    <section class="bg-white">
      <div class="md:px-4 max-w-screen-3xl mx-auto py-4">
        <div class="flex justify-center flex-wrap gap-8">
          <!-- Card 1 -->
          <div class="bg-white cursor-pointer shadow-lg rounded-full w-56 h-56 flex flex-col items-center justify-center transition-transform duration-300 hover:scale-105 hover:shadow-xl">
            <div
              class="w-10 h-10 bg-blue rounded-full flex justify-center items-center"
              @mouseenter="toggleIconState('phone')"
              @mouseleave="toggleIconState('phone')"
            >
              <i class="fa-solid fa-phone text-2xl text-white"></i>
            </div>
            <p class="text-center mt-4 text-gray-700 font-medium">
              <a href="tel:+2347068777793" class="text-blue-500 hover:underline">
                +234 706 877 7793
              </a>
            </p>
          </div>

          <!-- Card 2 -->
          <div class="bg-white cursor-pointer shadow-lg rounded-full w-56 h-56 flex flex-col items-center justify-center transition-transform duration-300 hover:scale-105 hover:shadow-xl">
            <div
              class="w-10 h-10 bg-blue rounded-full flex justify-center items-center"
              @mouseenter="toggleIconState('email')"
              @mouseleave="toggleIconState('email')"
            >
              <i class="fa-solid fa-envelope text-2xl text-white"></i>
            </div>
            <p class="text-center mt-4 text-gray-700 font-medium">
              <a href="mailto:info@barkaumshelia.com" class="text-blue-500 hover:underline">
                info&#64;barkaumshelia.com
              </a>
            </p>
          </div>

          <!-- Card 3 -->
          <div class="bg-white cursor-pointer shadow-lg rounded-full w-56 h-56 flex flex-col items-center justify-center transition-transform duration-300 hover:scale-105 hover:shadow-xl">
            <div
              class="w-10 h-10 bg-blue rounded-full flex justify-center items-center"
              @mouseenter="toggleIconState('location')"
              @mouseleave="toggleIconState('location')"
            >
              <i class="fa-solid fa-earth-oceania text-2xl text-white"></i>
            </div>
            <p class="text-center mt-4 text-gray-700 font-medium px-4">
              The Mshel Hub, No. 2 Julius Adelusi Street, Guzape, Abuja.
            </p>
          </div>

          <!-- Card 4 -->
          <div class="bg-white cursor-pointer shadow-lg rounded-full w-56 h-56 flex flex-col items-center justify-center transition-transform duration-300 hover:scale-105 hover:shadow-xl">
            <div
              class="w-10 h-10 bg-blue rounded-full flex justify-center items-center"
              @mouseenter="toggleIconState('hours')"
              @mouseleave="toggleIconState('hours')"
            >
              <i class="fa-solid fa-hourglass-start text-2xl text-white"></i>
            </div>
            <p class="text-center mt-4 text-gray-700 font-medium">
              Open hours: 8.00-17.00 Mon-Fri
            </p>
          </div>
        </div>
      </div>
    </section>

    <!-- Google map and image section -->
    <div class="md:px-4 max-w-screen-3xl mx-auto py-10">
      <h2 class="text-2xl font-semibold text-center mb-6">Visit Us</h2>
      <div class="grid md:grid-cols-1 gap-6 px-10">
        <!-- Google Map Embed -->
        <iframe
          class="w-full h-96 rounded-lg shadow-lg"
          frameborder="0"
          style="border:0"
          :src="mapSrc"
          allowfullscreen
        ></iframe>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  data() {
    return {
      address: 'The Mshel Hub, No. 2 Julius Adelusi Street, Guzape, Abuja',
    };
  },
  computed: {
    mapSrc() {
      const query = encodeURIComponent(this.address);
      return `https://www.google.com/maps?q=${query}&output=embed`;
    },
    staticMapImg() {
      const query = encodeURIComponent(this.address);
      return `https://maps.googleapis.com/maps/api/staticmap?center=${query}&zoom=15&size=600x400&markers=color:red%7C${query}`;
    },
  },
  methods: {
    toggleIconState(icon) {
      // Add your hover interactivity here if needed
    },
  },
};
</script>

<style scoped>
.bg-gray-100 {
  background-color: #f9f9f9;
}

.hover\:scale-105:hover {
  transform: scale(1.05);
}

.hover\:shadow-xl:hover {
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
}

svg path {
  fill: #fff !important;
  stroke: none !important;
  box-shadow: none !important;
}

svg {
  overflow: hidden !important;
}

.absolute.bottom-0 {
  line-height: 0 !important;
  padding-bottom: 0 !important;
  margin-bottom: -2px;
}

.overflow-hidden {
  overflow: hidden !important;
}
</style>
